import { Inject, Injectable } from '@angular/core';
import { DfsGlobalsService } from './../../core/dfs-globals.service';
import { NDfs } from '../../dfs.interfaces';

@Injectable({
    providedIn: 'any'
})
export class DfsScopeClassParserService implements NDfs.IParser {
    constructor(@Inject(NDfs.OPTIONS) private options: NDfs.IOptions) {}

    /**
     * Returns the value from string
     */
    parse(dfsGlobalsService: DfsGlobalsService, dfs: string, rule: NDfs.IParserRule): NDfs.ICssEntry[] {
        return [
            {
                prop: rule.prop,
                value: `${rule.parserOptions?.prefix && `${this.options.scope}-`}${dfs}`
            }
        ];
    }
}
